/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const createCustomerMessage = /* GraphQL */ `
  mutation CreateCustomerMessage(
    $input: CreateCustomerMessageInput!
    $condition: ModelCustomerMessageConditionInput
  ) {
    createCustomerMessage(input: $input, condition: $condition) {
      id
      name
      email
      phone
      subject
      message
      services
      attachmentKeys
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateCustomerMessage = /* GraphQL */ `
  mutation UpdateCustomerMessage(
    $input: UpdateCustomerMessageInput!
    $condition: ModelCustomerMessageConditionInput
  ) {
    updateCustomerMessage(input: $input, condition: $condition) {
      id
      name
      email
      phone
      subject
      message
      services
      attachmentKeys
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteCustomerMessage = /* GraphQL */ `
  mutation DeleteCustomerMessage(
    $input: DeleteCustomerMessageInput!
    $condition: ModelCustomerMessageConditionInput
  ) {
    deleteCustomerMessage(input: $input, condition: $condition) {
      id
      name
      email
      phone
      subject
      message
      services
      attachmentKeys
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createGalleryItem = /* GraphQL */ `
  mutation CreateGalleryItem(
    $input: CreateGalleryItemInput!
    $condition: ModelGalleryItemConditionInput
  ) {
    createGalleryItem(input: $input, condition: $condition) {
      id
      description
      facebookLink
      instagramLink
      imageKey
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateGalleryItem = /* GraphQL */ `
  mutation UpdateGalleryItem(
    $input: UpdateGalleryItemInput!
    $condition: ModelGalleryItemConditionInput
  ) {
    updateGalleryItem(input: $input, condition: $condition) {
      id
      description
      facebookLink
      instagramLink
      imageKey
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteGalleryItem = /* GraphQL */ `
  mutation DeleteGalleryItem(
    $input: DeleteGalleryItemInput!
    $condition: ModelGalleryItemConditionInput
  ) {
    deleteGalleryItem(input: $input, condition: $condition) {
      id
      description
      facebookLink
      instagramLink
      imageKey
      createdAt
      updatedAt
      __typename
    }
  }
`;
